import { getChapterByPageId } from '@editor2/components/CourseChangesDiff/helpers';
import { getChapterPages } from '@editor2/reducers/editor/adapters/helpers';
import { type Chapter } from '@editor2/types/chapter';
import { type CourseState } from '@editor2/types/courseState';
import { type Entity } from '@editor2/types/entity';

export const getPageOrdinalNumber = (state: CourseState, pageId: string) => {
	const parentChapter = getChapterByPageId(state.chapters, state.page_groups, pageId);
	const chapterPages = getChapterPages(state, parentChapter);

	return chapterPages.indexOf(pageId) + 1;
};

export const getChapterOrdinalNumber = (chapters: Entity<Chapter>, chapterId: string) => {
	return chapters.ids.indexOf(chapterId) + 1;
};
